// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import MapView from "../views/MapView.vue";
import CompareView from "../views/CompareView.vue";

const routes: Array<any> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    meta: { titel: "Over" },
  },
  {
    path: "/map/:id",
    name: "map",
    component: MapView,
    meta: { titel: "Projectenkaart" },
  },
  {
    path: "/compare/:id",
    name: "compare",
    component: CompareView,
    meta: { titel: "Projecten vergelijken" },
  },
];

const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(process.env.BASE_URL),
  routes,
});

// Elke weergave een eigen documenttitel. In een SPA verandert die anders nooit,
// terwijl kaart en vergelijker voor de gebruiker losse pagina's zijn — een
// schermlezer noemt de titel bij elke navigatie (WCAG 2.4.2).
router.afterEach((to: any) => {
  const app = (window as any).__APP_CONFIG__?.appName || "ProjectenMonitor";
  document.title = to.meta?.titel ? `${to.meta.titel} — ${app}` : app;
});

export default router;
